import React from 'react';
import PropTypes from 'prop-types';
import ceil from 'lodash/ceil';
import orderBy from 'lodash/orderBy';
import _get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping } from '@fortawesome/free-solid-svg-icons';

import Price from 'Containers/Utility/Price/Price';
import SpecialFormattedNumber from 'Containers/Utility/Price/SpecialFormattedNumber';
import { currencyCode } from 'Helpers/Geo/data';
import { history } from 'Redux/store';

import 'Components/PickAndMix/PickAndMixSubtotal.scss';

const PickAndMixSubtotal = ({ selectedProducts, tiers }) => {
  const calculatePrices = () => {
    const quantity = selectedProducts.length;
    let fullPrice = 0;

    if (selectedProducts && selectedProducts.length < 1) {
      return { fullPrice: 0, price: 0, discountPercent: 0 };
    }

    selectedProducts.forEach((p) => {
      fullPrice += p.price[currencyCode];
    });

    tiers.forEach((t) => {
      t.baseQuantity = t.quantity; // eslint-disable-line no-param-reassign
      t.basePrice = { ...t.price }; // eslint-disable-line no-param-reassign
    });

    const highestActiveTier = orderBy(tiers, 'quantity', 'desc').find(t => quantity >= t.quantity);

    if (!highestActiveTier) {
      return { fullPrice, price: fullPrice, discountPercent: 0 };
    }

    const adjustedTier = {
      ...highestActiveTier,
      quantity,
      price:
        ceil((highestActiveTier.price[currencyCode] / highestActiveTier.baseQuantity) * quantity),
    };

    const discountPercent = (fullPrice - adjustedTier.price) / fullPrice;

    return { fullPrice, price: adjustedTier.price, discountPercent };
  };


  const { fullPrice, discountPercent, price } = calculatePrices();
  const selectedProductsLength = _get(selectedProducts, 'length');
  const quantities = tiers?.map(tier => tier.quantity) || [];

  const buttonDisabled = quantities.every(quantity => selectedProductsLength < quantity);
  const hideDiscount = !discountPercent;

  return (
    <div className="PickAndMixSubtotal">
      <div className="PickAndMixSubtotal__topSection">
        <div className="PickAndMixSubtotal__title">
          <FormattedMessage
            id="PickAndMixSubtotal.subtotal"
            defaultMessage="Subtotal"
          />
        </div>
        <div className="PickAndMixSubtotal__PriceContainer">
          <div className="PickAndMixSubtotal__PriceContainer__price">
            <Price
              showZero
              price={{ [currencyCode]: price }}
            />
          </div>
          {!hideDiscount &&
            <div className="PickAndMixSubtotal__PriceContainer__wasPrice">
              <Price
                showZero
                price={{ [currencyCode]: fullPrice }}
              />
            </div>
          }
          {!hideDiscount &&
            <div className="PickAndMixSubtotal__PriceContainer__savingPercentage">
              -<SpecialFormattedNumber value={discountPercent} style="percent" />
            </div>
          }
        </div>
      </div>

      <div className="PickAndMixSubtotal__bottomSection">
        <button disabled={buttonDisabled} className="btn btn-primary PickAndMixSubtotal__addToCart" onClick={() => history.push('/cart')}>
          <FontAwesomeIcon icon={faCartShopping} />
          <FormattedMessage id="PickAndMixSubtotal.gotocart" defaultMessage="Go to cart" />
        </button>
      </div>
    </div>
  );
};

PickAndMixSubtotal.propTypes = {
  selectedProducts: PropTypes.arrayOf(PropTypes.object),
  tiers: PropTypes.arrayOf(PropTypes.object),
};

PickAndMixSubtotal.defaultProps = {
  selectedProducts: [],
  tiers: [],
};

export default PickAndMixSubtotal;
